import { Trans } from 'react-i18next';
import type { TFunction } from 'i18next';

/**
 * The confirm copy carries a `<b>` emphasis tag in every locale, so it has to go through
 * `Trans` — a plain `t()` renders the tag as literal text (#878). `t` is the caller's
 * already-namespaced translator.
 */
export const DeleteConfirmMessage = ({ t }: { t: TFunction }) => (
    <Trans t={t} i18nKey="deleteAccountModal.confirmMessage" components={{ b: <b /> }} />
);
